import { nanoid } from "nanoid";
import React, { FC } from "react";
import { IMessageWithLink } from "../../interfaces/Message/IMessageWithLink";

export const MessageWithLink: FC<IMessageWithLink> = ({ text }) => {
  const linkRegex = /(https?:\/\/[^\s]+)/g;
  if (text) {
    const messageWithLinks = text.split(linkRegex).map((part) => {
      const id = nanoid();
      if (part.match(linkRegex)) {
        return (
          <a key={id} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return <span key={id}>{part}</span>;
    });

    return <>{messageWithLinks}</>;
  }
  return <>{text}</>;
};
